/**
 * Apple Sign-in 回調處理 - Post-Redirect-Get Pattern
 *
 * 攔截 Apple Sign-in 的 POST 回調，透過 303 重導向轉換為 GET 請求。
 *
 * 流程：
 * 1. POST 請求：Apple 回調時，將授權資料存入短效 Cookie (60秒)，發送 303 重導向
 * 2. GET 請求：從 Cookie 還原授權資料到 Vuex Store，並清除 Cookie
 */

export default function ({ req, res, store }) {
  // 處理 POST 請求 (Apple Sign-in 回調)
  if (process.server && req && req.method === 'POST') {
    return new Promise((resolve, reject) => {
      let reqData = ''

      req.on('data', chunk => {
        reqData += chunk
      })

      req.on('end', () => {
        try {
          const params = new URLSearchParams(reqData)

          const code = params.get('code')
          const state = params.get('state')
          const user = params.get('user')

          const dataToStore = { code, state }
          if (user) dataToStore.user = user

          // 將資料序列化並存入短效 Cookie (60秒)
          const cookieValue = encodeURIComponent(JSON.stringify(dataToStore))
          res.setHeader('Set-Cookie', `apple_signin_post_body=${cookieValue}; Path=/; HttpOnly; Secure; SameSite=Lax; Max-Age=60`)

          // 發送 303 See Other 重導向，強制瀏覽器使用 GET 請求
          res.writeHead(303, { Location: req.url })
          res.end()
        } catch (error) {
          console.error('Error processing POST request in middleware:', error)
          resolve()
        }
      })

      req.on('error', reject)
    })
  }

  // 處理 GET 請求 (還原資料)
  if (process.server && req && req.method === 'GET') {
    const cookies = req.headers.cookie
    if (cookies) {
      const match = cookies.match(/apple_signin_post_body=([^;]+)/)
      if (match) {
        try {
          // 從 Cookie 還原資料並寫入 Vuex
          const cookieValue = decodeURIComponent(match[1])
          const data = JSON.parse(cookieValue)
          store.commit('postBody', data)

          // 清除 Cookie
          res.setHeader('Set-Cookie', 'apple_signin_post_body=; Path=/; HttpOnly; Secure; SameSite=Lax; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT')
        } catch (e) {
          console.error('Failed to parse apple_signin_post_body cookie', e)
        }
      }
    }
  }
}
